import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=7573820c&scoped=true&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=7573820c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7573820c",
  null
  
)

export default component.exports